// DTC Cart Upsell JS - Cleaned version
// Removed: insertSectionCartDrawer() - upsell is already rendered by Liquid server-side
// Removed: MutationObserver(subtree:true) - was causing x2 upsell and countdown jump
// Kept:    onChangeKsUpsellVariantSelector - variant image/price swap on dropdown change
(function () {

  // Handler khi user doi bien the trong dropdown upsell
  window.onChangeKsUpsellVariantSelector = function(select, event) {
    if (event) event.preventDefault();
    const imgSrc = select.options[select.selectedIndex].dataset.variantImg;
    if (imgSrc) {
      const img = select.closest('.cart-drawer-upsell-list-item')
                        .querySelector('.cart-drawer-upsell-list-item-left img');
      if (img) img.src = imgSrc;
    }
  };

})();
